import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import {
  Navbar,
  Hero,
  Services,
  About,
  Contact,
  Footer,
  AnimatedBackground,
  PrivacyPolicy,
  TermsOfService,
  ScrollToTop,
} from './components';
import { ThemeProvider } from './contexts/ThemeContext';
import translations from './i18n';
import './App.css';

function Home({ t, lang, setLang, scrollToSection }) {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    }
  }, [location.hash, scrollToSection]);

  return (
    <>
      <AnimatedBackground />
      <Navbar t={t} lang={lang} setLang={setLang} scrollToSection={scrollToSection} />
      <Hero t={t} scrollToSection={scrollToSection} />
      <Services t={t} />
      <About t={t} />
      <Contact t={t} />
      <Footer t={t} />
    </>
  );
}

function App() {
  const [lang, setLang] = useState('en');
  const t = translations[lang];
  const isRTL = lang === 'fa';

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className={`app ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  t={t}
                  lang={lang}
                  setLang={setLang}
                  scrollToSection={scrollToSection}
                />
              }
            />
            <Route
              path="/privacy"
              element={
                <>
                  <Navbar t={t} lang={lang} setLang={setLang} scrollToSection={scrollToSection} />
                  <PrivacyPolicy t={t} />
                  <Footer t={t} />
                </>
              }
            />
            <Route
              path="/terms"
              element={
                <>
                  <Navbar t={t} lang={lang} setLang={setLang} scrollToSection={scrollToSection} />
                  <TermsOfService t={t} />
                  <Footer t={t} />
                </>
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
